import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Competition } from 'app/models/competition'
import { Observable } from 'rxjs/Observable'
import { environment } from 'environments/environment'
import { DropdownMenuOption } from 'app/models/dropdown-menu-option'
import { BehaviorSubject } from 'rxjs'
import { SharepointData } from '../models/sharepoint-data'

@Injectable()
export class CompetitionService {

  private competitions: Competition[]
  private competition: Competition
  private error = null
  private apiUrl = environment.api.url + environment.api.competition.url
  private competitionChanged = new BehaviorSubject<SharepointData>(undefined)

  constructor(private http: HttpClient) {
  }

  getAll(id: string): Observable<Competition[]> {
    const options = id ? {params: new HttpParams().set('all', id)} : {}
    return this.http
      .get<any>(this.apiUrl, options)
      .map(res => res.Items.map(el => <Competition>el))
      .catch(err => Observable.throw(err || 'ServerErr'))
  }

  get(id: string): Observable<Competition> {
    const options = id ? {params: new HttpParams().set('competition', id)} : {}

    return this.http
      .get<Competition>(this.apiUrl, options)
      .map(res => <Competition>res)
      .catch(err => {
        if (!this.competition && !this.competitions.length) this.setError(err)
        return Observable.throw(err || 'ServerErr')
      })
  }

  create(competition: Competition): Observable<Competition> {
    return this.http
      .post<Competition>(this.apiUrl, competition)
      .map(res => <Competition>res)
      .catch(err => Observable.throw(err || 'ServerErr'))
  }

  update(competition: Competition): Observable<Competition> {
    return this.http
      .put<Competition>(this.apiUrl, competition)
      .map(res => <Competition>res)
      .catch(err => Observable.throw(err || 'ServerErr'))
  }

  deleteCompetition(competitionId: string): Observable<Competition> {
    const options = {params: new HttpParams().set('competition', competitionId)}
    return this.http.delete(this.apiUrl, options).map(res => <Competition>res)
      .catch(err => Observable.throw(err || 'ServerErr'))
  }

  getDropdownMenuOptions(): DropdownMenuOption[] {
    const items = this.getCompetitions(),
      options: DropdownMenuOption[] = []

    if (items) {
      items.map(item => options.push(new DropdownMenuOption(item.compUrl, item.displayName)))
    }

    return options
  }

  getCompetitionId(): string {
    const competition = this.getCompetitionSelected()
    return competition ? competition.id : null
  }

  getCompetitionUrl(): string {
    const competition = this.getCompetitionSelected()
    return competition ? competition.compUrl : null
  }

  getCompetitionSelected(): Competition {
    return this.competition
  }

  setCompetitionSelected(competition: Competition): void {
    this.competition = competition
    if (competition && competition.assetBackground) {
      this.competitionChanged.next(competition.assetBackground)
    } else {
      this.competitionChanged.next(null)
    }
  }

  getCompetitionSelectedSubscriber(): Observable<SharepointData> {
    return this.competitionChanged.asObservable()
  }

  getCompetitionSelectedById(id: string): Competition {
    const competitions = this.getCompetitions()
    let competition: Competition = null

    competitions.filter(el => el.id === id)
      .map(res => competition = res)

    return competition
  }

  getCompetitionSelectedByUrl(url: string): Competition {
    const competitions = this.getCompetitions()
    let competition: Competition = null

    competitions.filter(el => el.compUrl === url)
      .map(res => competition = res)

    return competition
  }

  getCompetitions(): Competition[] {
    return this.competitions
  }

  setCompetitions(competitions: Competition[]): void {
    this.competitions = competitions
  }

  setError(err): void {
    this.error = err
  }

  getError() {
    return this.error
  }
}



// WEBPACK FOOTER //
// ./src/app/services/competition.service.ts